import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* download3(action) {
  const { id, page, pageId, onlyURL, preview } = action;

  var payload = {
    action: "portal/download3",
    id,
    page,
    pageId,
    onlyURL,
    preview,
  };

  yield put(serverRequest(payload));
}

export default download3;
